const Sdata = [
  {
    id: 1,
    title: "50% Off For Your First Shopping",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quis lobortis consequat eu, quam etiam at quis ut convallis.",
    cover:
      "https://ds.rokomari.store/rokomari110/ProductNew20190903/260X372/Dui_Bon-Rabindranath_Tagore-3952e-175342.jpg",
  },
  {
    id: 2,
    title: "50% Off For Your First Shopping",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quis lobortis consequat eu, quam etiam at quis ut convallis.",
    cover:
      "https://d1jpltibqvso3j.cloudfront.net/images/product/329000/328373/250X360/328373.png",
  },
  {
    id: 3,
    title: "50% Off For Your First Shopping",
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quis lobortis consequat eu, quam etiam at quis ut convallis.",
    cover:
      "https://d1jpltibqvso3j.cloudfront.net/images/product/328000/327216/250X360/327216.png",
  },
];
export default Sdata;
